module.exports = __webpack_public_path__ + "img/forestorytellingtour_main_02.ce5f01ad.jpg";